module.exports = __webpack_public_path__ + "img/favicon.db64da98.svg";